export default __webpack_public_path__ + "static/media/dealmed-hero-bg-new.f88bc44b.webp";